
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsBadge',
  components: { DesignContentLayout }
};
